import axios from "axios";
import appConfigs from "@configs/app";

// Creating axios instance here cause the default implementation has
// x-csrf-token header which is rejected by WIRIS
const httpClient = axios.create({});

const getLatexFromMathML = (mathML) => {
  const url = "/mathml2latex";

  const postData = {
    mml: mathML,
  };

  return httpClient.post(url, postData, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    baseURL: appConfigs.wirisAPIRoot,
  });
};

export default {
  getLatexFromMathML,
};
